// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/data/common/svg/caret-right-to-line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/data/common/svg/caret-left-to-line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/data/common/svg/xmark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textArea,
.textAreaMount {
  width: 100%;
  height: 100%;
}

.textArea {
  display: flex;
  flex-direction: column;
}

.splitterSplit .textArea {
  border: 1px solid var(--line);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px #0000000d;
}

.textAreaHeader {
  --text-area-header-height: 26px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: #fff;
  height: var(--text-area-header-height)
}

.splitterSplit .textAreaHeader {
  height: auto;
  padding: 8px;
  border-bottom: 1px solid var(--line);
}

.textAreaHeaderContent {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  gap: 4px;
}

.textAreaHeaderDismiss,
.textAreaHeaderToggle {
  width: var(--text-area-header-height);
  height: var(--text-area-header-height);
  margin: 0;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: 8px;
  background-color: #fafafa;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  font-size: 0;
  cursor: pointer;
  position: relative;
}

.textAreaHeaderToggle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.textAreaHeaderToggleEditorOnly {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.textAreaHeaderDismiss {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.textAreaHeaderDismiss:hover,
.textAreaHeaderToggle:hover {
  background-color: var(--accent-tint);
  border-color: var(--accent);
}

.textAreaMount {
  flex: 1 1 auto;
}

.textAreaTextArea {
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  border: 0;
  outline: 0;
  padding: 10px;
  resize: none;
  font-family: 'Roboto Mono', monospace;
  font-size: var(--font-size-editor);
  background: linear-gradient(270deg, #ddd7d3 0px, #f3efed 60px);
}

.cm-wrap, .cm-editor { height: 100% }
.cm-scroller { overflow: auto }
.cm-content {
  padding-top: 8px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  /* padding bottom is handled by scrollPastEnd */
  font-size: var(--font-size-editor);
}
.cm-line {
  padding: 0 20px !important;
}

.splitterSplit .cm-content {
  padding-top: 18px !important;
}

.splitterSplit .cm-line {
  padding: 0 28px !important;
}

/* No active-line band — it fights the card edges and the calm look. */
.splitterSplit .cm-activeLine {
  background: transparent;
}

/* Increase the selector specificity to get over the built-in codemirror rules. */
:root {
  & .cm-tooltip.cm-tooltip-autocomplete {
    font-size: var(--font-size-editor);
    box-shadow: var(--modal-shadow);
    border-radius: var(--modal-radius);
    border-color: var(--modal-border-color);
    background: var(--modal-background);
  }

  & .cm-tooltip-autocomplete ul li[aria-selected] {
    background: var(--primary-color-dim);
  }

  & .cm-tooltip.cm-tooltip-autocomplete > ul > li {
      line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/TextArea.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAAgE;AAClE;;AAEA;EACE,yDAAmD;AACrD;;AAEA;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,kCAAkC;EAClC,8DAA8D;AAChE;;AAEA,uBAAuB,aAAa;AACpC,eAAe,eAAe;AAC9B;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,uBAAuB;AACzB;;AAEA,iFAAiF;AACjF;EACE;IACE,kCAAkC;IAClC,+BAA+B;IAC/B,kCAAkC;IAClC,uCAAuC;IACvC,mCAAmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;MACI,gBAAgB;EACpB;AACF","sourcesContent":[".textArea,\n.textAreaMount {\n  width: 100%;\n  height: 100%;\n}\n\n.textArea {\n  display: flex;\n  flex-direction: column;\n}\n\n.splitterSplit .textArea {\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 1px 3px #0000000d;\n}\n\n.textAreaHeader {\n  --text-area-header-height: 26px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  background: #fff;\n  height: var(--text-area-header-height)\n}\n\n.splitterSplit .textAreaHeader {\n  height: auto;\n  padding: 8px;\n  border-bottom: 1px solid var(--line);\n}\n\n.textAreaHeaderContent {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: 4px;\n}\n\n.textAreaHeaderDismiss,\n.textAreaHeaderToggle {\n  width: var(--text-area-header-height);\n  height: var(--text-area-header-height);\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background-color: #fafafa;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 16px 16px;\n  font-size: 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.textAreaHeaderToggle {\n  background-image: url(\"/data/common/svg/caret-right-to-line.svg\");\n}\n\n.textAreaHeaderToggleEditorOnly {\n  background-image: url(\"/data/common/svg/caret-left-to-line.svg\");\n}\n\n.textAreaHeaderDismiss {\n  background-image: url(\"/data/common/svg/xmark.svg\");\n}\n\n.textAreaHeaderDismiss:hover,\n.textAreaHeaderToggle:hover {\n  background-color: var(--accent-tint);\n  border-color: var(--accent);\n}\n\n.textAreaMount {\n  flex: 1 1 auto;\n}\n\n.textAreaTextArea {\n  width: calc(100% - 20px);\n  height: calc(100% - 20px);\n  border: 0;\n  outline: 0;\n  padding: 10px;\n  resize: none;\n  font-family: 'Roboto Mono', monospace;\n  font-size: var(--font-size-editor);\n  background: linear-gradient(270deg, #ddd7d3 0px, #f3efed 60px);\n}\n\n.cm-wrap, .cm-editor { height: 100% }\n.cm-scroller { overflow: auto }\n.cm-content {\n  padding-top: 8px !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  /* padding bottom is handled by scrollPastEnd */\n  font-size: var(--font-size-editor);\n}\n.cm-line {\n  padding: 0 20px !important;\n}\n\n.splitterSplit .cm-content {\n  padding-top: 18px !important;\n}\n\n.splitterSplit .cm-line {\n  padding: 0 28px !important;\n}\n\n/* No active-line band — it fights the card edges and the calm look. */\n.splitterSplit .cm-activeLine {\n  background: transparent;\n}\n\n/* Increase the selector specificity to get over the built-in codemirror rules. */\n:root {\n  & .cm-tooltip.cm-tooltip-autocomplete {\n    font-size: var(--font-size-editor);\n    box-shadow: var(--modal-shadow);\n    border-radius: var(--modal-radius);\n    border-color: var(--modal-border-color);\n    background: var(--modal-background);\n  }\n\n  & .cm-tooltip-autocomplete ul li[aria-selected] {\n    background: var(--primary-color-dim);\n  }\n\n  & .cm-tooltip.cm-tooltip-autocomplete > ul > li {\n      line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
